import { lazy } from "react";
import i18n from "i18next";
import type { GameModule } from "../types";
import { registerSnakeTranslations, SNAKE_NS } from "./i18n";

registerSnakeTranslations(i18n);

/** Snake: steer to the apples, grow, and never run into a wall or yourself. */
export const snakeModule: GameModule = {
  key: "snake",
  namespace: SNAKE_NS,
  Player: lazy(() => import("./Player")),
};
